import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import Errors from '../helpers/errors.js';

@customElement('error-directory')
export class ErrorDirectory extends LitElement {
  private __error?: Error;
  private __errorCode?: number;

  public get errorMessage() {
    return this.__error?.message;
  }

  public get errorCode() {
    return Number(this.__errorCode);
  }

  public set errorCode(code: number) {
    this.__errorCode = code;
    this.__setErrorMessage(this.__errorCode);
  }

  private __setErrorMessage(code: number) {
    switch (code) {
      case 0:
        this.__error = undefined;
        break;

      // Client Error responses
      case 400:
        this.__error = new Errors.BadRequest();
        break;
      case 401:
        this.__error = new Errors.Unauthorised();
        break;
      case 402:
        this.__error = new Errors.PaymentRequired();
        break;
      case 403:
        this.__error = new Errors.Forbidden();
        break;
      case 404:
        this.__error = new Errors.NotFound();
        break;
      case 405:
        this.__error = new Errors.MethodNotAllowed();
        break;
      case 406:
        this.__error = new Errors.NotAcceptable();
        break;
      case 408:
        this.__error = new Errors.RequestTimeout();
        break;
      case 411:
        this.__error = new Errors.LengthRequired();
        break;
      case 429:
        this.__error = new Errors.TooManyRequests();
        break;
      case 431:
        this.__error = new Errors.RequestHeaderFieldsTooLarge();
        break;

      // Server error responses
      case 500:
        this.__error = new Errors.InternalServerError();
        break;
      case 501:
        this.__error = new Errors.NotImplemented();
        break;
      case 502:
        this.__error = new Errors.BadGateway();
        break;
      case 503:
        this.__error = new Errors.ServiceUnavailable();
        break;
      case 504:
        this.__error = new Errors.GatewayTimeout();
        break;
      case 505:
        this.__error = new Errors.HTTPVersionNotSupported();
        break;
      case 511:
        this.__error = new Errors.NetworkAuthenticationRequired();
        break;

      default:
        this.__error = new Errors.SomethingGoneWrong();
        break;
    }
  }
}
